import { Extension } from "../extension";

export default class ModS extends Extension {
	get name() {
		return "Mod S";
	}
	keys() {
		return {
			"Mod-s": () => {
				return true;
			},
		};
	}
}
